import React, {
  useRef,
  useState,
  RefObject,
  useEffect,
  forwardRef,
  useImperativeHandle,
  ForwardRefRenderFunction,
} from 'react';
import { FormControl, Grid, Typography } from '@mui/material';

import Switch, { SwitchRef } from 'components/Common/InputComponents/Switch';

import { AlarmDefinition } from 'types/types';

export interface BusyHourRef {
  busyHour: RefObject<SwitchRef>;
  isShown: boolean;
  toggleShowBusyHourToggle: (show: boolean) => void;
}

interface Prop {
  alarmDefinitionData: AlarmDefinition | null;
}

const BusyHour: ForwardRefRenderFunction<BusyHourRef, Prop> = (
  { alarmDefinitionData },
  ref
) => {
  const [showBusyHour, setShowBusyHour] = useState<boolean>(false);

  const busyHourRef = useRef<SwitchRef>(null);

  const toggleShowBusyHourToggle = (show: boolean) => setShowBusyHour(show);

  useImperativeHandle(ref, () => ({
    busyHour: busyHourRef,
    isShown: showBusyHour,
    toggleShowBusyHourToggle,
  }));

  useEffect(() => {
    if (
      ['daily'].includes(
        alarmDefinitionData?.time_aggregation_level.toLowerCase() ?? ''
      )
    ) {
      setShowBusyHour(true);
    }
  }, [alarmDefinitionData]);

  if (showBusyHour) {
    return (
      <Grid item xs={4}>
        <Typography className="form-element-label">
          Use Busy Hour KPI Value
        </Typography>
        <FormControl fullWidth className="busy-hour-container">
          <Switch
            value={
              alarmDefinitionData?.execution_rules_serialized
                ?.useBusyHourKPIValue
            }
            ref={busyHourRef}
            className={`day-over-day-switch`}
          />
        </FormControl>
      </Grid>
    );
  } else {
    return <React.Fragment />;
  }
};

export default forwardRef<BusyHourRef, Prop>(BusyHour);
